"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainInfoPopover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const BlockchainInfoPopover = (props) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "contract-info" : undefined;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { zIndex: 1000 }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-describedby": id, onClick: handleClick, children: (0, jsx_runtime_1.jsx)(icons_material_1.Help, {}) }), (0, jsx_runtime_1.jsx)(material_1.Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.Table, { sx: { minWidth: 650 }, "aria-label": "contract parameters", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Table.Body, { children: Object.keys(props).map(key => ((0, jsx_runtime_1.jsxs)(ui_kit_1.Table.Row, { children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Table.Cell, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `form.labels.${key}` }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.Table.Cell, { children: Array.isArray(props[key]) ? props[key].join(", ") || "—" : props[key] })] }, key))) }) }) })] }));
};
exports.BlockchainInfoPopover = BlockchainInfoPopover;
//# sourceMappingURL=index.js.map